export default "__VITE_ASSET__8OuHX22J__"